import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Async } from '@/shared/ui/Async';
import { Badge } from '@/shared/ui/Badge';
import { Button } from '@/shared/ui/Button';

import { priorityColor, statusColor } from '../components/TicketDetail';
import { useMyTickets } from '../hooks/use-support';

export function MyTicketsRoute(): JSX.Element {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const query = useMyTickets();
  return (
    <main className="page stack">
      <div className="row row--between">
        <h1>{t('support.myTicketsTitle')}</h1>
        <Button onClick={() => navigate('/support/new')}>{t('support.newTicket')}</Button>
      </div>
      <Async query={query} isEmpty={(l) => l.length === 0} emptyMessage={t('support.noneYet')}>
        {(list) => (
          <div className="stack">
            {list.map((tk) => (
              <button
                key={tk.id}
                type="button"
                className="card card--interactive stack"
                onClick={() => navigate(`/support/tickets/${tk.id}`)}
              >
                <div className="row row--between">
                  <strong>{tk.subject}</strong>
                  <Badge label={t(`support.status_${tk.status}`)} color={statusColor(tk.status)} />
                </div>
                <div className="wrap">
                  <Badge
                    label={t(`support.priority_${tk.priority}`)}
                    color={priorityColor(tk.priority)}
                  />
                  <Badge
                    label={t(`support.category_${tk.category}`)}
                    color="var(--color-on-surface-muted)"
                  />
                  <span className="muted">{new Date(tk.createdAt).toLocaleDateString()}</span>
                </div>
              </button>
            ))}
          </div>
        )}
      </Async>
    </main>
  );
}
